import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useLazyQuery } from '@apollo/client'
import Papa from 'papaparse'
import FileSaver from 'file-saver'
import toast from 'react-hot-toast'
import '../styles/orders.css'
import ErrorLoading from '../components/layout/ErrorLoading'
import CenterLoader from '../components/spinners/CenterLoader'
import FilterForm from '../components/layout/FilterForm'
import Pagination from '../components/layout/Pagination'
import NoData from '../components/layout/NoData'
import { formatDownloadDeliveries } from '../utils/formatter'
import { ORDERS_DOWNLOAD_LIMIT } from '../utils/limits'
import { GET_DELIVERIES } from '../graphql/deliveries'
import DeliveriesView from '../components/deliveries/DeliveriesView'

function DeliveriesPage({ match }) {
  const { storeId } = match.params
  const [deliveries, setDeliveries] = useState(null)
  const limit = 10
  const [page, setPage] = useState(1)
  const [error, setError] = useState(null)
  const start = page === 1 ? 0 : (page - 1) * limit

  const handleResponse = (data) => {
    setError(null)
    setDeliveries(data.merchantDeliveries)
  }

  const [getDeliveries, { loading }] = useLazyQuery(GET_DELIVERIES, {
    fetchPolicy: 'network-only',
    onError: () => { setError(true) },
    onCompleted: handleResponse,
  })
  const getDeliveriesReq = () => {
    getDeliveries({
      variables: {
        limit,
        storeId,
        offset: start,
        orderNo: null,
        status: ['pending', 'dispatched', 'completed', 'cancelled'],
      },
    })
  }
  const handleDownloadResponse = (data) => {
    const downloadData = data.merchantDeliveries || []
    const formattedData = formatDownloadDeliveries(downloadData)
    const dataStr = JSON.stringify(formattedData)
    const csv = Papa.unparse(dataStr)
    const blob = new Blob([decodeURIComponent(encodeURI(csv))], {
      type: 'text/csv;charset=utf-8;',
    })
    toast.dismiss('downloadspinner')
    toast.success('Data downloaded')
    FileSaver.saveAs(blob, 'deliveries.csv')
  }
  const [getDownloadData] = useLazyQuery(GET_DELIVERIES, {
    fetchPolicy: 'cache-and-network',
    onError: () => { toast.dismiss('downloadspinner'); toast.error('Error downloading data') },
    onCompleted: handleDownloadResponse,
  })

  const prevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }
  const nextPage = () => {
    if (!(deliveries.length < limit)) {
      setPage(page + 1)
    }
  }
  const download = (period) => {
    toast.loading('Downloading data...', { id: 'downloadspinner' })
    getDownloadData(
      {
        variables: {
          limit: ORDERS_DOWNLOAD_LIMIT,
          offset: 0,
          period,
          status: ['scheduled', 'pending', 'preparing', 'dispatched', 'completed', 'cancelled'],
        },
      },
    )
  }

  useEffect(() => {
    getDeliveriesReq()
  }, [page])

  return (
    <div className="page-content">
      <FilterForm download={download} defaultRangeDays={0} />
      <CenterLoader visible={loading} />
      <ErrorLoading visible={error && !loading} reload={getDeliveries} />
      {!loading && !error && deliveries ? <DeliveriesView deliveries={deliveries} /> : null }
      <NoData visible={!loading && !error && !deliveries?.length} />
      <Pagination visible={!loading && !error && deliveries?.length} page={page} next={nextPage} prev={prevPage} />
    </div>
  )
}

const mapStateToProps = (state) => ({
  userInfo: state.user.userInfo,
})

export default connect(mapStateToProps, {})(DeliveriesPage)
